(function ($) {
	function selectFirstProductComparison() {
		var target = $( ".product-tabs > ul.items > li:first" );
		if (target.length > 0) {
			$(target).click();
		}
	}
	function buildProductComparisonHeaderToolbar() {
		var target = $( ".product-tabs > ul.items" );
		var i = 0;
		if (target.length > 0) {
			$.each($('.product-comparison-table th'), function() {
				if (i > 0) {
					var $li = $('<li></li>');
					$li.addClass('product');
					var $button = $('<button></button>');
					$button.html($(this).html());
					$li.append($button);
					$(target).append($li);
				}
				i++;
			});
		}
	}
	$(document).on("ready", function () {
		var productComparisonTable = $( ".product-tabs" );
		
		if (productComparisonTable.length > 0) {
			// build header
			buildProductComparisonHeaderToolbar();
			
			$( ".product-tabs > ul.items > li" ).on( "click", function() {
				var items = $( ".product-tabs > ul.items > li" );
				var itemCount = items.length;
				var pos = $(this).index()+2;
				$(".product-comparison-table tr").find('td:not(:eq(0))').removeClass('active');
				$('.product-comparison-table').find('td:nth-child('+pos+')').addClass('active');
				$('.product-tabs > ul.items > li').removeClass('active');
				$(this).addClass('active');
				// check prev/next to activate/deactivate buttons
				//console.log('POS: '+ pos + ' ITEMCOUNT: ' + itemCount);
				if (pos <= itemCount) {
					$( ".product-tabs > .arrow.next" ).addClass('active');
				} else {
					$( ".product-tabs > .arrow.next" ).removeClass('active');
				}
				if (pos > 2) {
					$( ".product-tabs > .arrow.prev" ).addClass('active');
				} else {
					$( ".product-tabs > .arrow.prev" ).removeClass('active');
				}
			});
			// Previous and next buttons
			$( ".product-tabs > .arrow" ).click(function(e) {
				e.preventDefault();
				if ($(this).hasClass('prev')) {
					$( ".product-tabs li.active").prev().children('button').click();
				} else if ($(this).hasClass('next')) {
					$( ".product-tabs li.active").next().children('button').click();
				}
			});
			$(window).on('changed.zf.mediaquery', function(event, newSize, oldSize) {
				if (('small' === newSize || 'medium' === newSize) && oldSize !== 'small' && oldSize !== 'medium') {
					selectFirstProductComparison();
				}
			});
			if ('small' === Foundation.MediaQuery.current || 'medium' === Foundation.MediaQuery.current) {
				selectFirstProductComparison();
			}
		}
	});
}(jQuery));